import Vue from "vue";
import Vconsole from 'vconsole'
export default {
    isConsole(){
        if(
            process.env.VUE_APP_BASIC_API !== 'prod'
        ){
            let vConsole = new Vconsole()
            Vue.use(vConsole)
        }
    },
}
